/** @format */

import React from "react";

export default () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 0.5H5C5.31416 0.5 5.61049 0.648334 5.79958 0.901197L6.39958 1.70354C6.77705 2.20831 7.36989 2.50587 8 2.50587H16.5C17.0509 2.50587 17.5 2.95417 17.5 3.51026V14.0411C17.5 14.5972 17.0509 15.0455 16.5 15.0455H1.5C0.949094 15.0455 0.5 14.5972 0.5 14.0411V1.5044C0.5 0.948303 0.949095 0.5 1.5 0.5Z"
      stroke="#874439"
    />
    <path
      d="M12.3345 8.08203V9.48828H10.7525V11.082H9.34624V9.48828H7.7642V8.08203H9.34624V6.5H10.7525V8.08203H12.3345Z"
      fill="#874439"
    />
  </svg>
);
